// src/store/reducers/authReducer.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import jwt from 'jwt-decode'
import axios from 'axios'
import { base_url } from '../../utils/config'

// In development hit your local backend (no CORS issues),
// in production hit the real base_url
const LOCAL_API = 'http://localhost:5000'
const SERVER    = process.env.NODE_ENV === 'development'
  ? LOCAL_API
  : base_url

// -----------------------
// Thunks
// -----------------------

export const customer_register = createAsyncThunk(
  'auth/customer_register',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await axios.post(
        `${SERVER}/api/customer/customer-register`,
        info,
        { withCredentials: true }
      )
      localStorage.setItem('customerToken', data.token)
      return fulfillWithValue(data)
    } catch (error) {
      console.error('Register API error:', error)
      return rejectWithValue(
        error.response?.data || { error: error.message }
      )
    }
  }
)

export const customer_login = createAsyncThunk(
  'auth/customer_login',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await axios.post(
        `${SERVER}/api/customer/customer-login`,
        info,
        { withCredentials: true }
      )
      localStorage.setItem('customerToken', data.token)
      return fulfillWithValue(data)
    } catch (error) {
      console.error('Login API error:', error)
      return rejectWithValue(
        error.response?.data || { error: error.message }
      )
    }
  }
)

// -----------------------
// Utility to decode and validate token
// -----------------------

const decodeToken = (token) => {
  if (!token) return ''
  try {
    const userInfo = jwt(token)
    const expireTime = new Date(userInfo.exp * 1000)
    if (new Date() > expireTime) {
      localStorage.removeItem('customerToken')
      return ''
    }
    return userInfo
  } catch {
    localStorage.removeItem('customerToken')
    return ''
  }
}

// -----------------------
// Slice
// -----------------------

export const authReducer = createSlice({
  name: 'auth',
  initialState: {
    loader: false,
    userInfo: decodeToken(localStorage.getItem('customerToken')),
    errorMessage: '',
    successMessage: '',
    token: localStorage.getItem('customerToken')
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
    user_reset: (state) => {
      state.userInfo = ''
      state.token = ''
    }
  },
  extraReducers: {
    // register
    [customer_register.pending]: (state) => {
      state.loader = true
    },
    [customer_register.rejected]: (state, { payload }) => {
      state.loader = false
      state.errorMessage = payload.error
    },
    [customer_register.fulfilled]: (state, { payload }) => {
      state.loader = false
      state.successMessage = payload.message
      state.userInfo = decodeToken(payload.token)
      state.token = payload.token
    },

    // login
    [customer_login.pending]: (state) => {
      state.loader = true
    },
    [customer_login.rejected]: (state, { payload }) => {
      state.loader = false
      state.errorMessage = payload.error
    },
    [customer_login.fulfilled]: (state, { payload }) => {
      state.loader = false
      state.successMessage = payload.message
      state.userInfo = decodeToken(payload.token)
      state.token = payload.token
    }
  }
})

export const { messageClear, user_reset } = authReducer.actions
export default authReducer.reducer
